(function () {
  var indicator = document.getElementById('gallery-scroll-indicator');
  var galleryWrap = document.querySelector('.product-gallery-wrap');
  var thumb = document.getElementById('gallery-scroll-thumb');
  var upBtn = document.getElementById('gallery-scroll-up');
  var downBtn = document.getElementById('gallery-scroll-down');

  if (!indicator || !galleryWrap || !thumb) return;

  var desktopMQ = window.matchMedia('(min-width: 768px)');

  function setVisible() {
    var needsScroll = galleryWrap.scrollHeight > galleryWrap.clientHeight;
    indicator.classList.toggle('is-visible', desktopMQ.matches && needsScroll);
  }

  function updateThumb() {
    if (!desktopMQ.matches) return;
    var scrollTop = galleryWrap.scrollTop;
    var scrollHeight = galleryWrap.scrollHeight;
    var clientHeight = galleryWrap.clientHeight;
    var scrollable = scrollHeight - clientHeight;
    var track = indicator.querySelector('.gallery-scroll-track');
    var trackHeight = track.offsetHeight;

    if (scrollable <= 0) return;

    var thumbHeight = Math.max(20, Math.round(trackHeight * clientHeight / scrollHeight));
    thumb.style.height = thumbHeight + 'px';
    thumb.style.top = Math.round((scrollTop / scrollable) * (trackHeight - thumbHeight)) + 'px';
  }

  galleryWrap.addEventListener('scroll', updateThumb, { passive: true });

  desktopMQ.addEventListener('change', function () {
    setVisible();
    updateThumb();
  });

  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(function () {
      setVisible();
      updateThumb();
    }).observe(galleryWrap);
  }

  upBtn.addEventListener('click', function () {
    galleryWrap.scrollBy({ top: -300, behavior: 'smooth' });
  });

  downBtn.addEventListener('click', function () {
    galleryWrap.scrollBy({ top: 300, behavior: 'smooth' });
  });

  setVisible();
  updateThumb();
})();
